import invoicePoolConfig from './invoice-pool/invoice-pool'
import invoiceCollectionConfig from './invoice-pool/invoice-collection'
import deductionCheckConfig from './use-invoice/deduction-check'
import intoAccountConfig from './use-invoice/into-account'
import ruleConfigurationConfig from './use-invoice/rule-configuration'
import invoicingConfig from './invoicing'
import policyConfig from './policy'
import firmConfig from './firm'
import messageConfig from './message'
import billingStatisticsConfig from './billing-statistics'
import blacklistConfig from './blacklist'
import itemsInfoConfig from './bill-infos/items-info'
import customerConfig from './bill-infos/customer-info'
import additionalInfoConfig from './bill-infos/additional-info'
import fastInvoiceConfig from './fast-invoice'
import orderConfig from './order'
import taxRefundCheckConfig from './use-invoice/tax-refund-check'
import intelligentCheckConfig from './use-invoice/intelligent-check'
export default {
  ...invoicePoolConfig,
  ...invoiceCollectionConfig,
  ...deductionCheckConfig,
  ...intoAccountConfig,
  ...ruleConfigurationConfig,
  ...invoicingConfig,
  ...policyConfig,
  ...firmConfig,
  ...messageConfig,
  ...billingStatisticsConfig,
  ...blacklistConfig,
  ...itemsInfoConfig,
  ...customerConfig,
  ...additionalInfoConfig,
  ...fastInvoiceConfig,
  ...orderConfig,
  ...taxRefundCheckConfig,
  ...intelligentCheckConfig
}
